/* tslint:disable */

import React, {Component, ReactElement, ReactNode, RefObject} from 'react'
import NatMessageRepo from '../message/repository/NatMessageRepo'
import NatCondominiumRepo from '../condominium/repository/NatCondominiumRepo'
import NatCurrentDateTimeRepo from '../currentDateTime/repository/NatCurrentDateTimeRepo'
import {
    MessageNotDeliveryCondominiumList,
    MessageRegisteredFileList,
    NatPostMessage,
    NatPostMessageParams,
} from './repository/NatPostMessage'
import {
    ADMINISTORATOR_MODE,
    AVAILABLE_OR_NOT,
    MESSAGE_CATEGORY,
    MESSAGE_CATEGORY_FOR_LEVEL4,
    MESSAGE_CATEGORY_FOR_MANAGEMENT_UNION,
    MESSAGE_TYPE,
    PREFECTURES_MASTER,
    ROLE_FOR_ADMINISTRATOR,
    SELECT_CONDOMINIUM_TYPE,
    SET_EXISTENCE,
    VALID_OR_NOT_CHECK,
} from '../../../CodeMaster'
import {AdminPagePropsSet, createAdminPage} from '../../../components/shared/hoc/createAdminPage'
import EventEmitterExAdmin from '../../../components/shared/pageBaseComponents/EventEmitterExAdmin'
import {Nullable} from '../../../app/TypeHelpers'
import NatCondominiumGroupRepo from '../condominiumGroup/repository/NatCondominiumGroupRepo'
import {NatGetCondominiumGroup} from '../condominiumGroup/repository/NatGetCondominiumGroup'
import {CurrentDateTime, NatGetCurrentDateTime} from '../currentDateTime/repository/NatGetCurrentDateTime'
import {Messages} from '../../../Messages'
import {
    PageFooterArea,
    PageFotterAreaLeft,
    PageFotterAreaRight,
    PageMainArea,
} from '../../../components/shared/hoc/withAdminPageTemplate'
import NatDeliveryTargetAreaSelectionComponent from '../common/admin/NatDeliveryTargetAreaSelectionComponent'
import {AdminDefaultMediumButton, AdminPrimaryButton} from '../../../styledComponents/adminPage/Buttons'
import {BackLink, DeleteLink, StyledLink} from '../../../styledComponents/adminPage/Links'
import {
    InnerMiniTable,
    InnerMiniTableBody,
    InnerMiniTableCell,
    StyledTableCaption,
    TableRowName,
} from '../../../styledComponents/adminPage/Table'
import PPSelect, {OptionProps} from '../../../components/shared/forms/PPSelect'
import {SessionStorageHelper} from '../../../SessionStorageHelper'
import PPTextField from '../../../components/shared/forms/PPTextField'
import PPHtmlEditor from '../../../components/shared/forms/PPHtmlEditor'
import PPCheckboxGroup from '../../../components/shared/forms/PPCheckboxGroup'
import PPInput from '../../../components/shared/forms/PPInput'
import PPNumericField from '../../../components/shared/forms/PPNumericField'
import {CondominiumInfo} from '../condominium/repository/NatGetCondominiumList'
import NatCondominiumSelectionComponent from '../common/admin/NatCondominiumSelectionComponent'
import {getYearAfterNextDate, getYearDate, openPdfPreviewWindow} from '../../common/util/Natutil'
import PPDatePicker from '../../../components/shared/forms/PPDatePicker'
import {formatForDateInput} from '../../../formatters/formatDate'
import {
    FlexStartRowFlexContainer,
    LeftRowFlexContainer,
    RowFlexContainer,
} from '../../../styledComponents/FlexComponents';
import {StyledDiv, StyledLabel, StyledSpan} from '../../../styledComponents/StyledTypeDefinitions';
import styled from 'styled-components';
import NatCondominiumGroupSelectComponent from '../common/NatCondominiumGroupSelectComponent';
import PPFileInput from '../../../components/shared/forms/PPFileInput';
import {Box, Dialog, Link, Table, TableBody, TableCell, TableRow} from '@mui/material';
import {NatCreatePreviewForResident} from '../common/admin/NatCreatePreviewForResident';
import NatMessageForResidentComponent from './common/NatMessageForResidentComponent';
import PPRadioGroup from "../../../components/shared/forms/PPRadioGroup";
import {NatGetMessage} from "./repository/NatGetMessage";
import {MessageFileList} from "./repository/NatPutMessage";
import {isIE} from "react-device-detect"
import PPErrorLabel from "../../../components/shared/forms/PPErrorLabel";
import {FontWeights} from "../../../styledComponents/Constants";
import {SelectChangeEvent} from '@mui/material/Select'
import {NatDoNotifyNotice} from './common/NatAdminMessageComponent'
import {Location} from 'react-router-dom'

const KEY_SELECTED_ADMINISTORATOR_MODE: string = 'selectedMode'
const KEY_LOGIN_USER_CONDOMINIUM_GROUP_ID: string = 'loginUserCondominiumGroupId'
const KEY_LOGIN_USER_ROLE_ID: string = 'loginUserRoleId'

const CreatePreviewForResident = NatCreatePreviewForResident({})(NatMessageForResidentComponent)

interface Props {
    condominiumRepo: NatCondominiumRepo
    messageRepo: NatMessageRepo,
    messageId: string
    condominiumGroupRepo: NatCondominiumGroupRepo
    currentDateTimeRepo: NatCurrentDateTimeRepo
    eventEmitter: EventEmitterExAdmin
    location: Location
}

interface States {
    condominiumGroup: NatGetCondominiumGroup
    messageRegisterParams: NatPostMessageParams
    currentDateTime: CurrentDateTime
    deliveryTargetPrefectureCd: string
    deliveryTargetAddress2: string
    selectedDeliveryTargetCondominiumInfo: CondominiumInfo[]
    dialogOpenSelectDeliveryTargetArea: boolean
    publishStartDateMin: string
    publishStartDateMax: string
    publishEndDateMin: string
    publishEndDateMax: string
    messageFileList: CustomMessageFileList[]
    fileName: string
    publishMaterialName: string
    fileData: string | ArrayBuffer | null
    fileSize: number
    addMessageFileButtonDisabled: boolean
    isLoadCompleted: boolean
    loginUserRoleId: string | null
    dialogOpenSelectExcludeCondominium: boolean
    selectedExcludeCondominiumInfo: CondominiumInfo[]
    loginUserCondominiumGroupId: number | null
    selectCondominiumGroupId: number | null
    fileInputDisabled: boolean
    doNotifyDisabled: boolean
    preview: boolean
    copyAvailability: string
}

interface CustomMessageFileList extends MessageRegisteredFileList {
    registeredFlag: boolean
    deleteFlag?: boolean
}

class NatAdminMessageRegisterPage extends Component<Props & AdminPagePropsSet, States> {

    mode: Nullable<string>
    messageFile: RefObject<HTMLInputElement>

    constructor(props: Props & AdminPagePropsSet) {
        super(props)

        this.mode = SessionStorageHelper.getStringItemOrNull(KEY_SELECTED_ADMINISTORATOR_MODE)

        const loginUserCondominiumGroupId: Nullable<number> =
            SessionStorageHelper.getNumberItemOrNull(KEY_LOGIN_USER_CONDOMINIUM_GROUP_ID)

        const loginUserRoleId: Nullable<string> =
            SessionStorageHelper.getStringItemOrNull(KEY_LOGIN_USER_ROLE_ID)

        const messageRegisterParams: NatPostMessageParams = {
            messageNotDeliveryCondominium: [],
            categoryId: '',
            title: '',
            description: '',
            publishStartDate: '',
            publishEndDate: '',
            topFixed: VALID_OR_NOT_CHECK.NOT.value,
            copyAvailability: AVAILABLE_OR_NOT.UNAVAILABLE.value,
            messageFile: [],
            doNotify: SET_EXISTENCE.NOT.value
        }
        if (loginUserCondominiumGroupId) {
            messageRegisterParams.condominiumGroupId = loginUserCondominiumGroupId
        }

        this.state = {
            condominiumGroup: {
                ['details']: null,
                ['informations']: [],
                ['requestError']: null,
                ['requestItemErrors']: [],
            },
            selectedDeliveryTargetCondominiumInfo: [],
            deliveryTargetPrefectureCd: '',
            deliveryTargetAddress2: '',
            dialogOpenSelectDeliveryTargetArea: false,
            messageRegisterParams: messageRegisterParams,
            currentDateTime: {
                currentDateTime: '',
                holidayFlag: '',
            },
            publishStartDateMin: '',
            publishStartDateMax: '',
            publishEndDateMin: '',
            publishEndDateMax: '',
            messageFileList: [],
            fileName: '',
            publishMaterialName: '',
            fileData: '',
            fileSize: 0,
            addMessageFileButtonDisabled: true,
            isLoadCompleted: false,
            loginUserRoleId: loginUserRoleId,
            dialogOpenSelectExcludeCondominium: false,
            selectedExcludeCondominiumInfo: [],
            loginUserCondominiumGroupId: loginUserCondominiumGroupId,
            selectCondominiumGroupId: loginUserCondominiumGroupId,
            fileInputDisabled: false,
            doNotifyDisabled: false,
            preview: false,
            copyAvailability: AVAILABLE_OR_NOT.UNAVAILABLE.value,
        }
        this.messageFile = React.createRef()

        this.setSelectedExclusionCondominiumInfo = this.setSelectedExclusionCondominiumInfo.bind(this)
        this.handleOpenExclusionCondominiumSelectionDialog =
            this.handleOpenExclusionCondominiumSelectionDialog.bind(this)
        this.registerMessageButton = this.registerMessageButton.bind(this)
        this.closeSelectCondominiumDiaLog = this.closeSelectCondominiumDiaLog.bind(this)
        this.changeTopFixed = this.changeTopFixed.bind(this)
        this.changeCategoryId = this.changeCategoryId.bind(this)
        this.changeTitle = this.changeTitle.bind(this)
        this.changeDescription = this.changeDescription.bind(this)
        this.changePublishStartDate = this.changePublishStartDate.bind(this)
        this.changePublishEndDate = this.changePublishEndDate.bind(this)
        this.handleRegisterCancelClick = this.handleRegisterCancelClick.bind(this)
        this.handleRegisterOkClick = this.handleRegisterOkClick.bind(this)
        this.onChangeSelectedCondominiumGroupId = this.onChangeSelectedCondominiumGroupId.bind(this)
        this.changePublishMaterialName = this.changePublishMaterialName.bind(this)
        this.changeFile = this.changeFile.bind(this)
        this.addMessageFile = this.addMessageFile.bind(this)
        this.changeMessageFileSortOrder = this.changeMessageFileSortOrder.bind(this)
        this.changeMessagePublishName = this.changeMessagePublishName.bind(this)
        this.changeMessageFileSortOrder = this.changeMessageFileSortOrder.bind(this)
        this.previewOpenButton = this.previewOpenButton.bind(this)
        this.previewCloseButton = this.previewCloseButton.bind(this)
        this.changeCopyAvailability = this.changeCopyAvailability.bind(this)
        this.validMessageFileCount = this.validMessageFileCount.bind(this)
        this.handleOpenDeliveryTargetAreaSelectionDialog =
            this.handleOpenDeliveryTargetAreaSelectionDialog.bind(this)
        this.handleCloseDeliveryTargetAreaSelectionDialog =
            this.handleCloseDeliveryTargetAreaSelectionDialog.bind(this);
        this.setSelectedDeliveryTargetCondominiumInfo = this.setSelectedDeliveryTargetCondominiumInfo.bind(this);
        this.setDeliveryTargetPrefectureCd = this.setDeliveryTargetPrefectureCd.bind(this);
        this.setDeliveryTargetAddress2 = this.setDeliveryTargetAddress2.bind(this);
        this.changeDoNotify = this.changeDoNotify.bind(this)
        this.onClinkDoNotify = this.onClinkDoNotify.bind(this)
    }

    async componentDidMount(): Promise<void> {
        await this.props.eventEmitter.showLoading()
        try {
            // 全体モード時のみ物件グループを取得
            if (this.mode === ADMINISTORATOR_MODE.ALL.value) {
                const condominiumGroupResponse: Nullable<NatGetCondominiumGroup> = await this.props.asyncCallFunction(
                    this.props.condominiumGroupRepo.getCondominiumGroup.bind(this.props.condominiumGroupRepo),
                    (httpErrorOrNetworkError) => {
                        this.props.eventEmitter.showHeadingAreaMessage(httpErrorOrNetworkError)
                    },
                )
                if (condominiumGroupResponse && condominiumGroupResponse.details) {
                    this.setState({condominiumGroup: condominiumGroupResponse})
                }

            }

            // 現在日時
            const currentDateTime: Nullable<NatGetCurrentDateTime> = await this.props.asyncCallFunction(
                this.props.currentDateTimeRepo.getCurrentDateTime.bind(this.props.currentDateTimeRepo),
                (httpErrorOrNetworkError) => {
                    this.props.eventEmitter.showHeadingAreaMessage(httpErrorOrNetworkError)
                },
            )
            let maxDate: string = ''
            if (currentDateTime && currentDateTime.details) {
                // システム稼働年度頭
                const minDate: string = getYearDate()
                // システム日付の翌々年度末
                maxDate = getYearAfterNextDate(currentDateTime.details.currentDateTime)
                this.setState({
                    publishStartDateMin: minDate,
                    publishStartDateMax: maxDate,
                    publishEndDateMin: minDate,
                    publishEndDateMax: maxDate,
                    currentDateTime: currentDateTime.details,
                })
            }
            if (this.props.messageId) {
                // メッセージ取得
                const getMessageResponse: Nullable<NatGetMessage> = await this.props.asyncCallFunction(
                    this.props.messageRepo.getMessage.bind(this.props.messageRepo, this.props.messageId),
                    (httpErrorOrNetworkError) => {
                        this.props.eventEmitter.showHeadingAreaMessage(httpErrorOrNetworkError)
                    },
                )
                if (getMessageResponse && getMessageResponse.details) {
                    const messageFileList: CustomMessageFileList[] = []
                    if (getMessageResponse.details.messageFile) {
                        getMessageResponse.details.messageFile.forEach((file, index) => {
                            const messageFile: CustomMessageFileList = {
                                fileNumber: file.fileNumber,
                                sortOrder: file.sortOrder,
                                publishMaterialName: file.publishMaterialName,
                                fileName: file.fileName,
                                path: file.path,
                                registeredFlag: true,
                                deleteFlag: false,
                            }
                            messageFileList.push(messageFile)
                        })
                    }

                    const loginUserCondominiumGroupId: Nullable<number> =
                        SessionStorageHelper.getNumberItemOrNull(KEY_LOGIN_USER_CONDOMINIUM_GROUP_ID)

                    const PostMessageParamMessageNotDeliveryCondominium: MessageNotDeliveryCondominiumList[] = []
                    getMessageResponse.details.messageNotDeliveryCondominium.map((condominiumInfo) => {
                        PostMessageParamMessageNotDeliveryCondominium.push({condominiumCd: condominiumInfo.condominiumCd})
                    })
                    const messageRegisterParams: NatPostMessageParams = {
                        messageCopyOrgId: getMessageResponse.details.messageId,
                        categoryId: getMessageResponse.details.categoryId,
                        messageNotDeliveryCondominium: [],
                        title: getMessageResponse.details.title,
                        description: getMessageResponse.details.description,
                        topFixed: VALID_OR_NOT_CHECK.NOT.value,
                        copyAvailability: AVAILABLE_OR_NOT.UNAVAILABLE.value,
                        publishStartDate: getMessageResponse.details.publishStartDate,
                        publishEndDate: getMessageResponse.details.publishEndDate,
                        messageRegisteredFileList: messageFileList,
                        // 通知有無は、コピー元の設定値に関わらず「設定なし」とする
                        doNotify: SET_EXISTENCE.NOT.value
                    }
                    if (loginUserCondominiumGroupId) {
                        messageRegisterParams.condominiumGroupId = loginUserCondominiumGroupId
                    }
                    this.setState({
                        messageRegisterParams: messageRegisterParams,
                        messageFileList: messageFileList,
                        publishStartDateMax: getMessageResponse.details.publishEndDate ?? maxDate,
                        publishEndDateMin: getMessageResponse.details.publishStartDate,
                            fileInputDisabled: false,
                        }, () => {
                            this.updateDoNotifyDisabled()
                        }
                    );
                }
            }
        } finally {
            this.props.eventEmitter.closeLoading()
            this.setState({isLoadCompleted: true})
        }
    }

    handleOpenDeliveryTargetAreaSelectionDialog(): void {
        this.setState({
            dialogOpenSelectDeliveryTargetArea: true,
        })
    }

    handleCloseDeliveryTargetAreaSelectionDialog(): void {
        this.setState({dialogOpenSelectDeliveryTargetArea: false})
    }

    onChangeSelectedCondominiumGroupId(condomoniumGroupId: number): void {
        const messageRegisterParams: NatPostMessageParams = this.state.messageRegisterParams
        messageRegisterParams.condominiumGroupId = condomoniumGroupId

        // 物件グループを変更する度に除外する物件をクリアする
        this.setState({selectedExcludeCondominiumInfo: []})
        messageRegisterParams.messageNotDeliveryCondominium = []

        this.setState({messageRegisterParams: messageRegisterParams, selectCondominiumGroupId: condomoniumGroupId})
    }

    changeCategoryId(event: SelectChangeEvent<unknown>): void {
        const messageRegisterParams: NatPostMessageParams = this.state.messageRegisterParams;
        messageRegisterParams.categoryId = event.target.value as string;
        this.setState({messageRegisterParams: messageRegisterParams},
            () => {
                this.updateDoNotifyDisabled()
            }
        )
    }

    changeTitle(event: React.ChangeEvent<HTMLInputElement>): void {
        const messageRegisterParams: NatPostMessageParams = this.state.messageRegisterParams
        messageRegisterParams.title = event.target.value
        this.setState({messageRegisterParams: messageRegisterParams})
    }


    changeDescription(value: string): void {
        const messageRegisterParams: NatPostMessageParams = this.state.messageRegisterParams
        messageRegisterParams.description = value
        this.setState({messageRegisterParams: messageRegisterParams})
    }

    changePublishStartDate(date: Nullable<Date>): void {
        const messageRegisterParams: NatPostMessageParams = this.state.messageRegisterParams
        if (date !== null) {
            messageRegisterParams.publishStartDate = formatForDateInput(date.toString())
        } else {
            messageRegisterParams.publishStartDate = ''
        }
        this.setState({
            publishEndDateMin: date !== null ? formatForDateInput(date.toString()) : getYearDate(),
            messageRegisterParams: messageRegisterParams,
        })
    }

    changePublishEndDate(date: Nullable<Date>): void {
        const messageRegisterParams: NatPostMessageParams = this.state.messageRegisterParams
        if (date !== null) {
            messageRegisterParams.publishEndDate = formatForDateInput(date.toString())
        } else {
            messageRegisterParams.publishEndDate = ''
        }
        this.setState({
            publishStartDateMax: date !== null ? formatForDateInput(date.toString()) :
                getYearAfterNextDate(this.state.currentDateTime.currentDateTime),
            messageRegisterParams: messageRegisterParams,
        })
    }

    changeTopFixed(): void {
        const messageRegisterParams: NatPostMessageParams = this.state.messageRegisterParams
        if (this.state.messageRegisterParams.topFixed === VALID_OR_NOT_CHECK.VALID.value) {
            messageRegisterParams.topFixed = VALID_OR_NOT_CHECK.NOT.value
        } else {
            messageRegisterParams.topFixed = VALID_OR_NOT_CHECK.VALID.value
        }
        this.setState({messageRegisterParams: messageRegisterParams})
    }

    previewMessageFile(dataUri: string): void {
        const data: string[] = dataUri.split(',')
        if (data[1]) {
            openPdfPreviewWindow(data[1])
        }
    }

    validMessageFileCount(): number {
        const messageFileList = this.state.messageFileList
        const validMessageFileCount = messageFileList.filter(file => file.deleteFlag === false).length
        return validMessageFileCount
    }

    changeFile(event: React.ChangeEvent<HTMLInputElement>): void {
        // ファイル情報取得
        if (event.target.files && event.target.files[0] && event.target.files[0].name) {
            if (this.state.publishMaterialName) {
                this.setState({addMessageFileButtonDisabled: false})
            } else {
                this.setState({addMessageFileButtonDisabled: true})
            }
            this.setState({
                fileName: event.target.files[0].name,
                fileSize: event.target.files[0].size,
            })
            const reader: FileReader = new FileReader()
            reader.onload = () => {
                this.setState({fileData: reader.result})
            }
            reader.readAsDataURL(event.target.files[0])
        } else {
            this.setState({
                fileName: '',
                fileData: '',
                fileSize: 0,
                addMessageFileButtonDisabled: true,
            })
        }
    }

    changePublishMaterialName(event: React.ChangeEvent<HTMLInputElement>): void {
        if (event.target.value && this.state.fileName) {
            this.setState({addMessageFileButtonDisabled: false})
        } else {
            this.setState({addMessageFileButtonDisabled: true})
        }
        this.setState({publishMaterialName: event.target.value})
    }

    changeMessagePublishName(event: React.ChangeEvent<HTMLInputElement>): void {
        const messageFileList = this.state.messageFileList
        messageFileList[Number(event.target.name)].publishMaterialName = event.target.value
        this.setState({messageFileList: messageFileList})
    }

    changeMessageFileSortOrder(event: React.ChangeEvent<HTMLInputElement>): void {
        const messageFileList = this.state.messageFileList
        messageFileList[Number(event.target.name)].sortOrder = Number(event.target.value)
        this.setState({messageFileList: messageFileList})
    }

    addMessageFile(): void {
        const messageFileList = this.state.messageFileList
        const validMessageFileList = messageFileList.filter(file => file.deleteFlag === false)
        const addFileList = validMessageFileList.filter(file => file.registeredFlag === false)
        const messageFile: CustomMessageFileList = {
            ['sortOrder']: validMessageFileList.length + 1,
            ['fileName']: this.state.fileName,
            ['fileSize']: this.state.fileSize,
            ['fileData']: this.state.fileData,
            ['publishMaterialName']: this.state.publishMaterialName,
            ['registeredFlag']: false,
            ['deleteFlag']: false,
        }
        messageFileList.push(messageFile)
        this.setState({
            fileName: '',
            fileSize: 0,
            fileData: '',
            publishMaterialName: '',
            addMessageFileButtonDisabled: true,
            messageFileList: messageFileList,
            fileInputDisabled: (addFileList.length + 1 >= 3),
        })
        // 追加したタイミングで選択したファイルをクリア
        if (this.messageFile.current && this.messageFile.current.value) {
            this.messageFile.current.value = ''
        }
    }

    deleteMessageFile(index: number): void {
        const messageFileList = this.state.messageFileList
        messageFileList[index].deleteFlag = true
        messageFileList[index].fileData = null
        const addFileCount = messageFileList.filter(file => file.registeredFlag === false
            && file.deleteFlag === false)
        this.setState({
            messageFileList: messageFileList,
            fileInputDisabled: (addFileCount.length >= 3),
        })
    }

    changeDoNotify(doNotify: SET_EXISTENCE): void {
        const messageRegisterParams = this.state.messageRegisterParams
        messageRegisterParams.doNotify = doNotify.value
        this.setState({messageRegisterParams: messageRegisterParams})
    }

    judgRegisterMessageButton(): boolean {

        if (this.mode === ADMINISTORATOR_MODE.ALL.value) {
            if (!this.state.messageRegisterParams.condominiumGroupId) {
                return true
            }
        }
        return !(this.state.messageRegisterParams.categoryId &&
            this.state.messageRegisterParams.title &&
            this.state.messageRegisterParams.description &&
            this.state.messageRegisterParams.publishStartDate
        )
    }

    setSelectedDeliveryTargetCondominiumInfo(selectedDeliveryTargetCondominiumInfo: CondominiumInfo[]): void {
        selectedDeliveryTargetCondominiumInfo.sort(
            (a, b) => Number(a.condominiumCd) - Number(b.condominiumCd),
        )
        this.setState({
            selectedDeliveryTargetCondominiumInfo: selectedDeliveryTargetCondominiumInfo,
            dialogOpenSelectDeliveryTargetArea: false,
        })
    }

    setDeliveryTargetPrefectureCd(deliveryTargetPrefectureCd: string): void {
        this.setState({
            deliveryTargetPrefectureCd: deliveryTargetPrefectureCd,
        })
    }

    setDeliveryTargetAddress2(deliveryTargetAddress2: string): void {
        this.setState({
            deliveryTargetAddress2: deliveryTargetAddress2,
        })
    }

    getPrefectureName(prefectureCd: string): string {
        if (prefectureCd) {
            const prefecturesMaster = PREFECTURES_MASTER.codeToEnumConstants(prefectureCd)
            return prefecturesMaster.label
        } else {
            return ''
        }
    }

    async onClinkDoNotify(): Promise<void> {
        if (this.state.messageRegisterParams.doNotify === SET_EXISTENCE.SET.value) {
            return this.changeDoNotify(SET_EXISTENCE.NOT)
        }
        await this.props.eventEmitter.showDialog({
                title: '通知有無の設定確認',
                errorLevel: MESSAGE_TYPE.INFORMATION,
                message: <NatDoNotifyNotice/>,
                buttonProps: [
                    {
                        isDefault: false,
                        buttonLabel: '設定しない',
                        buttonHandler: () => {
                            this.changeDoNotify(SET_EXISTENCE.NOT);
                            this.props.eventEmitter.closeDialog()
                        },
                    },
                    {
                        isDefault: false,
                        buttonLabel: '設定する',
                        buttonHandler: () => {
                            this.changeDoNotify(SET_EXISTENCE.SET);
                            this.props.eventEmitter.closeDialog()
                        },
                    },
                ],
            },
        )
    }

    async registerMessageButton(): Promise<void> {

        await this.props.eventEmitter.showDialog({
                title: '確認',
                errorLevel: Messages.IOPCC0012.errorLevel,
                message: Messages.IOPCC0012.toString('メッセージ'),
                buttonProps: [
                    {
                        isDefault: false,
                        buttonLabel: 'キャンセル',
                        buttonHandler: this.handleRegisterCancelClick,
                    },
                    {
                        isDefault: false,
                        buttonLabel: 'OK',
                        buttonHandler: this.handleRegisterOkClick,
                    },
                ],
            },
        )

    }

    handleRegisterCancelClick(): void {
        this.props.eventEmitter.closeDialog()
    }

    async handleRegisterOkClick(): Promise<void> {
        this.props.eventEmitter.closeDialog()
        await this.props.eventEmitter.showLoading()
        try {
            const messageRegisterParams = this.state.messageRegisterParams
            if (this.state.deliveryTargetAddress2) {
                messageRegisterParams.deliveryTargetAddress2 = this.state.deliveryTargetAddress2
            }
            if (this.state.deliveryTargetPrefectureCd) {
                messageRegisterParams.deliveryTargetPrefectureCd = this.state.deliveryTargetPrefectureCd
            }
            if (this.state.messageFileList) {
                const messageFileList: MessageRegisteredFileList[] = []
                this.state.messageFileList.forEach((file, index) => {
                    const fileData: string[] = String(file.fileData).split(',')
                    if (file.deleteFlag === true) {
                        return
                    }
                    if (fileData[1]) {
                        let messageFile: MessageFileList
                        if (file.fileNumber) {
                            messageFile = {
                                fileNumber: file.fileNumber,
                                sortOrder: file.sortOrder,
                                publishMaterialName: file.publishMaterialName,
                                path: file.path,
                                fileName: file.fileName,
                                fileData: fileData[1],
                                fileSize: file.fileSize,
                                fileIndex: index,
                            }
                        } else {
                            messageFile = {
                                sortOrder: file.sortOrder,
                                publishMaterialName: file.publishMaterialName,
                                fileName: file.fileName,
                                fileData: fileData[1],
                                fileSize: file.fileSize,
                                fileIndex: index,
                            }
                        }
                        messageFileList.push(messageFile)
                    } else {
                        messageFileList.push(file)
                    }
                })
                messageRegisterParams.messageRegisteredFileList = messageFileList
            }
            messageRegisterParams.messageNotDeliveryCondominium = []
            if (this.state.selectedExcludeCondominiumInfo.length > 0) {
                this.state.selectedExcludeCondominiumInfo.map((condominiumInfo) => {
                    messageRegisterParams.messageNotDeliveryCondominium.push(
                        {condominiumCd: condominiumInfo.condominiumCd},
                    )
                })
            }

            const registerMessageResponse: Nullable<NatPostMessage> = await this.props.asyncCallFunction(
                this.props.messageRepo.postMessage.bind(this.props.messageRepo, messageRegisterParams),
                async (httpErrorOrNetworkError) => {
                    await httpErrorOrNetworkError.broadcast(this.props.eventEmitter)
                },
                {defaultErrorTitle: Messages.EOPCA0001.toString('メッセージ')},
            )
            if (registerMessageResponse &&
                registerMessageResponse.details &&
                registerMessageResponse.requestError === null
            ) {
                this.props.navigate(`/admin/message/${registerMessageResponse.details.messageId}`,
                    {
                        state: {
                            initialMessage: {
                                title: null,
                                messageLevel: MESSAGE_TYPE.INFORMATION,
                                detail: Messages.IOPCC0004.toString('メッセージ',
                                    messageRegisterParams.title ? messageRegisterParams.title : ''),
                            },
                        },
                    },
                )
            }
        } finally {
            this.props.eventEmitter.closeLoading()
        }

    }

    getCategoryList(): OptionProps[] {

        let categories: OptionProps[] = []

        if (this.state.loginUserRoleId === ROLE_FOR_ADMINISTRATOR.SYSTEM_ADMIN.value ||
            this.state.loginUserRoleId === ROLE_FOR_ADMINISTRATOR.CALL_CENTER.value ||
            this.state.loginUserRoleId === ROLE_FOR_ADMINISTRATOR.FRONT_STAFF.value
        ) {
            categories = MESSAGE_CATEGORY.values().map((messageCategory) => {
                return ({
                    label: `${messageCategory.label}`,
                    value: `${messageCategory.value}`,
                })
            })
        }

        if (this.state.loginUserRoleId === ROLE_FOR_ADMINISTRATOR.LIFE_MANAGER.value ||
            this.state.loginUserRoleId === ROLE_FOR_ADMINISTRATOR.CONCIERGE.value
        ) {
            categories = MESSAGE_CATEGORY_FOR_LEVEL4.values().map((messageCategory) => {
                return ({
                    label: `${messageCategory.label}`,
                    value: `${messageCategory.value}`,
                })
            })
        }

        if (this.state.loginUserRoleId === ROLE_FOR_ADMINISTRATOR.ASSOC.value
        ) {
            categories = MESSAGE_CATEGORY_FOR_MANAGEMENT_UNION.values().map((messageCategory) => {
                return ({
                    label: `${messageCategory.label}`,
                    value: `${messageCategory.value}`,
                })
            })
        }


        return [{
            label: 'カテゴリを選択してください',
            value: '',
        }, ...categories]
    }

    closeSelectCondominiumDiaLog(): void {
        this.setState({dialogOpenSelectExcludeCondominium: false})
    }

    setSelectedExclusionCondominiumInfo(selectedExcludeCondominiumInfo: CondominiumInfo[]): void {
        selectedExcludeCondominiumInfo.sort((a, b) => Number(a.condominiumCd) - Number(b.condominiumCd))
        this.setState({
            selectedExcludeCondominiumInfo: selectedExcludeCondominiumInfo,
            dialogOpenSelectExcludeCondominium: false,
        })
    }

    handleOpenExclusionCondominiumSelectionDialog(): void {
        this.setState({
            dialogOpenSelectExcludeCondominium: true,
        })
    }

    changeCopyAvailability(event: React.ChangeEvent<HTMLInputElement>): void {
        const messageRegisterParams: NatPostMessageParams = this.state.messageRegisterParams
        messageRegisterParams.copyAvailability = event.target.value as string
        this.setState({messageRegisterParams: messageRegisterParams})
        this.setState({copyAvailability: event.target.value})
    }


    deleteExcludeCondominium(condominiumCd: string): void {
        const selectedExcludeCondominiumInfo: CondominiumInfo[] = []
        this.state.selectedExcludeCondominiumInfo.map((condominiumInfo) => {
            if (condominiumInfo.condominiumCd !== condominiumCd) {
                selectedExcludeCondominiumInfo.push(condominiumInfo)
            }
        })
        this.setState({selectedExcludeCondominiumInfo: selectedExcludeCondominiumInfo})
    }

    previewOpenButton(): void {
        this.setState({preview: true})
    }

    previewCloseButton(): void {
        this.setState({preview: false})
    }

    updateDoNotifyDisabled(): void {
        const {messageRegisterParams} = this.state

        let doNotifyDisabled = false
        if (messageRegisterParams.categoryId === MESSAGE_CATEGORY.MANAGEMENT_COMPANY_PR.value) {
            messageRegisterParams.doNotify = SET_EXISTENCE.NOT.value
            doNotifyDisabled = true
        }

        this.setState({
            messageRegisterParams: messageRegisterParams,
            doNotifyDisabled: doNotifyDisabled
        })
    }

    renderInputFormTable(): ReactNode {

        return (
            <>
                <Table>
                    <StyledTableCaption>メッセージ情報</StyledTableCaption>
                    <TableBody>
                        {this.mode === ADMINISTORATOR_MODE.ALL.value &&
                            <>
                                <TableRow>
                                    <TableRowName required>掲載範囲</TableRowName>

                                    {
                                        this.state.condominiumGroup &&
                                        this.state.condominiumGroup.details &&
                                        <>
                                            <TableRowName>物件グループ</TableRowName>
                                            <TableCell colSpan={3}>
                                                <NatCondominiumGroupSelectComponent
                                                    condominiumGroup={this.state.condominiumGroup.details}
                                                    defaultValue={this.state.loginUserCondominiumGroupId}
                                                    onChangeSelectedCondominiumGroupId=
                                                        {this.onChangeSelectedCondominiumGroupId}
                                                    requiredFlag={true}
                                                    eventKeys={['condominiumGroupId']}
                                                    eventEmitter={this.props.eventEmitter}
                                                    autoFocus={true}
                                                >
                                                </NatCondominiumGroupSelectComponent>
                                            </TableCell>
                                        </>
                                    }
                                </TableRow>
                                {this.renderDeliveryTargetArea()}
                                {this.mode === ADMINISTORATOR_MODE.ALL.value &&
                                    <TableRow>
                                        <TableRowName rowSpan={this.state.selectedExcludeCondominiumInfo.length + 1}>
                                            除外する物件を選択
                                        </TableRowName>
                                        <TableCell colSpan={4}>
                                            <AdminDefaultMediumButton
                                                onClick={this.handleOpenExclusionCondominiumSelectionDialog}
                                                size={'small'}
                                            >
                                                物件を選択
                                            </AdminDefaultMediumButton>
                                        </TableCell>
                                    </TableRow>
                                }
                                {this.state.dialogOpenSelectExcludeCondominium && this.state.condominiumGroup.details &&
                                    <NatCondominiumSelectionComponent
                                        selectCondominiumType={SELECT_CONDOMINIUM_TYPE.EXCLUDE_CONDOMINIUM.value}
                                        condominiumRepo={this.props.condominiumRepo}
                                        condominiumGroupRepo={this.props.condominiumGroupRepo}
                                        closeSelectCondominiumDiaLog={this.closeSelectCondominiumDiaLog}
                                        setSelectedExclusionCondominiumInfo={this.setSelectedExclusionCondominiumInfo}
                                        eventEmitter={this.props.eventEmitter}
                                        selectedCondominiumGroupId={this.state.selectCondominiumGroupId}
                                        navigate={this.props.navigate}
                                        location={this.props.location}
                                        asyncCallFunction={this.props.asyncCallFunction}
                                        excludeCondominium={this.state.selectedExcludeCondominiumInfo}
                                    />
                                }
                                {this.state.selectedExcludeCondominiumInfo.length > 0 &&
                                    this.state.selectedExcludeCondominiumInfo.map((condominiumInfo, index) => {
                                        return (
                                            <TableRow>
                                                <TableCell colSpan={4}>
                                                    <LeftRowFlexContainer>
                                                        <SelectedNotDeliveryCondominium>
                                                            <PPInput
                                                                type="label"
                                                                value={condominiumInfo.condominiumCd +
                                                                    ' ' + condominiumInfo.condominiumName}
                                                                eventKeys={
                                                                    [`messageNotDeliveryCondominium[${index}].condominiumCd`]
                                                                }
                                                                eventEmitter={this.props.eventEmitter}
                                                            />
                                                        </SelectedNotDeliveryCondominium>
                                                        <SelectedNotDeliveryCondominium>
                                                            <DeleteLink onClick={(event: React.MouseEvent) => {
                                                                event.preventDefault()
                                                                this.deleteExcludeCondominium(
                                                                    condominiumInfo.condominiumCd,
                                                                )
                                                            }}>
                                                                削除
                                                            </DeleteLink>
                                                        </SelectedNotDeliveryCondominium>
                                                    </LeftRowFlexContainer>
                                                </TableCell>
                                            </TableRow>
                                        )
                                    })
                                }
                            </>
                        }
                        <TableRow>
                            <TableRowName required>カテゴリ</TableRowName>
                            <TableCell colSpan={4}>
                                <PPSelect
                                    defaultValue={this.state.messageRegisterParams.categoryId}
                                    data={this.getCategoryList()}
                                    onChange={this.changeCategoryId}
                                    eventKeys={['categoryId']}
                                    eventEmitter={this.props.eventEmitter}
                                    autoFocus={(this.mode === ADMINISTORATOR_MODE.ALL.value) ?
                                        false : true}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableRowName required>タイトル</TableRowName>
                            <TableCell colSpan={4}>
                                <PPTextField
                                    InputProps={{
                                        inputProps: {
                                            maxLength: 50,
                                        },
                                    }}
                                    required
                                    fullWidth
                                    value={this.state.messageRegisterParams.title}
                                    onChange={this.changeTitle}
                                    eventKeys={['title']}
                                    eventEmitter={this.props.eventEmitter}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableRowName required hint={Messages.HNTFA0001.toString()}>
                                本文
                            </TableRowName>
                            <TableCell colSpan={4}>
                                <PPHtmlEditor
                                    onEditorChange={this.changeDescription}
                                    value={this.state.messageRegisterParams.description}
                                    eventKeys={['description']}
                                    eventEmitter={this.props.eventEmitter}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableRowName required>掲載開始日</TableRowName>
                            <TableCell colSpan={4}>
                                <LeftRowFlexContainer>
                                    <TermWrapper>
                                        <FlexBasis style={{paddingBottom: 4.5, paddingTop: 7.7}}>
                                            <PPDatePicker
                                                onChangeDate={this.changePublishStartDate}
                                                value={(this.state.messageRegisterParams.publishStartDate) ?
                                                    new Date(this.state.messageRegisterParams.publishStartDate) : null
                                                }
                                                eventEmitter={this.props.eventEmitter}
                                                eventKeys={['publishStartDate']}
                                                minDate={(this.state.publishStartDateMin !== '') ?
                                                    new Date(this.state.publishStartDateMin) : undefined
                                                }
                                                maxDate={(this.state.publishStartDateMax !== '') ?
                                                    new Date(this.state.publishStartDateMax) : undefined
                                                }
                                            />
                                        </FlexBasis>
                                    </TermWrapper>
                                </LeftRowFlexContainer>
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableRowName>掲載終了日</TableRowName>
                            <TableCell colSpan={4}>
                                <LeftRowFlexContainer>
                                    <TermWrapper>
                                        <FlexBasis style={{paddingBottom: 4.5, paddingTop: 7.7}}>
                                            <PPDatePicker
                                                onChangeDate={this.changePublishEndDate}
                                                value={(this.state.messageRegisterParams.publishEndDate) ?
                                                    new Date(this.state.messageRegisterParams.publishEndDate) : null
                                                }
                                                eventEmitter={this.props.eventEmitter}
                                                eventKeys={['publishEndDate']}
                                                minDate={(this.state.publishEndDateMin !== '') ?
                                                    new Date(this.state.publishEndDateMin) : undefined
                                                }
                                                maxDate={(this.state.publishEndDateMax !== '') ?
                                                    new Date(this.state.publishEndDateMax) : undefined
                                                }
                                            />
                                        </FlexBasis>
                                    </TermWrapper>
                                </LeftRowFlexContainer>
                            </TableCell>
                        </TableRow>
                        {this.mode === ADMINISTORATOR_MODE.CONDOMINIUM.value &&
                        <>
                            <TableRow>
                                <TableRowName hint={Messages.HNTFA0002.toString()}>
                                    上位固定
                                </TableRowName>
                                <TableCell colSpan={4}>
                                    <PPCheckboxGroup
                                        data={
                                            [
                                                {
                                                    label: '上位固定する（最大2件まで）',
                                                    checked: this.state.messageRegisterParams.topFixed
                                                        === VALID_OR_NOT_CHECK.VALID.value,
                                                },
                                            ]
                                        }
                                        onChangeChecked={this.changeTopFixed}
                                        eventKeys={['topFixed']}
                                        eventEmitter={this.props.eventEmitter}
                                        hint={Messages.HNTFA0002.toString()}
                                    />
                                </TableCell>
                            </TableRow>
                        </>
                        }
                        {this.mode === ADMINISTORATOR_MODE.ALL.value &&
                            <>
                                <TableRow>
                                    <TableRowName required>コピー可否</TableRowName>
                                    <TableCell colSpan={4}>
                                        <PPRadioGroup
                                            row
                                            data={AVAILABLE_OR_NOT.values()}
                                            value={this.state.copyAvailability}
                                            eventKeys={['copyAvailability']}
                                            eventEmitter={this.props.eventEmitter}
                                            onChange={this.changeCopyAvailability}
                                        />
                                    </TableCell>
                                </TableRow>
                            </>
                        }
                        <TableRow>
                            <TableRowName
                                {...{
                                    rowSpan: this.validMessageFileCount() !== 0 ?
                                        this.validMessageFileCount() + 1 : 1,
                                }}
                            >掲載資料</TableRowName>
                            <TableCell colSpan={4}>
                                <FlexStartRowFlexContainer>
                                    <DocumentNameWrapper>
                                        <TableCellLabelNoLeftPadding>掲載資料名</TableCellLabelNoLeftPadding>
                                        <PPTextField
                                            InputProps={{
                                                inputProps: {
                                                    id: 'publishMaterialName',
                                                    maxLength: 50,
                                                },
                                            }}
                                            required
                                            fullWidth
                                            onChange={this.changePublishMaterialName}
                                            eventKeys={['publishMaterialName']}
                                            value={this.state.publishMaterialName}
                                            eventEmitter={this.props.eventEmitter}
                                            disabled={this.state.fileInputDisabled}
                                        />
                                    </DocumentNameWrapper>
                                    <DocumentWrapper>
                                        <DocumentFormWrapper>
                                            <PPFileInput
                                                InputProps={{
                                                    inputProps: {
                                                        id: 'messageFile',
                                                        name: 'messageFile',
                                                    },
                                                }}
                                                fullWidth
                                                inputRef={this.messageFile}
                                                onChange={this.changeFile}
                                                fileName={this.state.fileName}
                                                eventKeys={['messageFile']}
                                                eventEmitter={this.props.eventEmitter}
                                                disabled={this.state.fileInputDisabled}
                                            />
                                        </DocumentFormWrapper>
                                        <div style={{color: 'red', flex: '1 0 auto'}}>※5MBまで</div>
                                    </DocumentWrapper>
                                    <DocumentAddButtonWrapper>
                                        <AdminPrimaryButton
                                            onClick={this.addMessageFile}
                                            disabled={this.state.addMessageFileButtonDisabled
                                                || this.state.fileInputDisabled}
                                        >PDFを追加
                                        </AdminPrimaryButton>
                                    </DocumentAddButtonWrapper>
                                </FlexStartRowFlexContainer>
                            </TableCell>
                        </TableRow>
                        {this.renderFileArea()}
                        <TableRow>
                            <TableRowName hint={Messages.HNTFA0004.toString()}>
                                通知有無
                            </TableRowName>
                            <TableCell colSpan={4}>
                                <PPCheckboxGroup
                                    data={
                                        [{
                                            label: '居住者に通知する',
                                            checked: this.state.messageRegisterParams.doNotify === SET_EXISTENCE.SET.value,
                                            checkboxProps: {disabled: this.state.doNotifyDisabled}
                                        }]
                                    }
                                    onChangeChecked={this.onClinkDoNotify}
                                    eventKeys={['doNotify']}
                                    eventEmitter={this.props.eventEmitter}
                                />
                            </TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
            </>
        )
    }

    renderFileArea(): ReactNode {
        return <>
            {this.state.messageFileList.map((messageFile, index) => (
                (messageFile.deleteFlag === false) ?
                    <TableRow key={index}>
                        <TableCell colSpan={3}>
                            <RowFlexContainer>
                                <AlreadyDocumentWrapper>
                                    <TableCellLabelNoLeftPadding>
                                        {(messageFile.fileData) ?
                                            <a href="javascript:void(0)"
                                               onClick={(event: React.MouseEvent<HTMLElement>) => {
                                                   event.preventDefault()
                                                   this.previewMessageFile(messageFile.fileData as string)
                                               }}>
                                                <img
                                                    src={`/resources/images/icons/icon_pdf.png`}
                                                    alt=""/>
                                            </a> : (isIE) ?
                                                <Link
                                                    onClick={() => window.open(messageFile.path)}
                                                    target={'_blank'}
                                                    underline="hover">
                                                    <img
                                                        src={
                                                            `/resources/images/icons/icon_pdf.png`
                                                        }
                                                        alt=""
                                                    />
                                                </Link> :
                                                <Link href={messageFile.path} target={'_blank'} underline="hover">
                                                    <img
                                                        src={
                                                            `/resources/images/icons/icon_pdf.png`
                                                        }
                                                        alt=""
                                                    />
                                                </Link>
                                        }
                                    </TableCellLabelNoLeftPadding>
                                    <PPInput
                                        type="text"
                                        inputProps={{
                                            maxLength: 50,
                                        }}
                                        name={String(index)}
                                        value={messageFile.publishMaterialName}
                                        onChange={this.changeMessagePublishName.bind(this)}
                                        eventKeys={[`messageFile[${index}].publishMaterialName`]}
                                        eventEmitter={this.props.eventEmitter}
                                    />
                                </AlreadyDocumentWrapper>
                                <TableCellLabelNoLeftPadding>
                                    並び順
                                </TableCellLabelNoLeftPadding>
                                <OrderWrapper>
                                    <DocumentFormWrapper>
                                        <PPNumericField
                                            InputProps={{
                                                inputProps: {
                                                    min: 1,
                                                    max: 999,
                                                },
                                            }}
                                            fullWidth
                                            name={String(index)}
                                            onChange={this.changeMessageFileSortOrder}
                                            value={messageFile.sortOrder}
                                            eventKeys={[`messageFile[${index}].sortOrder`]}
                                            eventEmitter={this.props.eventEmitter}
                                        />
                                    </DocumentFormWrapper>
                                </OrderWrapper>
                                <AlreadyDocumentWrapper>
                                    <TableCellLabelNoLeftPadding>
                                        <StyledLink onClick={() => this.deleteMessageFile(index)}>
                                            削除
                                        </StyledLink>
                                    </TableCellLabelNoLeftPadding>
                                </AlreadyDocumentWrapper>
                            </RowFlexContainer>
                        </TableCell>
                    </TableRow>
                    : null
            ))}
        </>
    }

    renderPageFooterArea(): ReactNode {

        return (
            <>
                <PageFotterAreaRight>
                    <Box pr={'15px'}>
                        <AdminPrimaryButton
                            disabled={this.judgRegisterMessageButton()}
                            onClick={this.previewOpenButton}
                        >
                            メッセージプレビュー
                        </AdminPrimaryButton>
                    </Box>
                    <AdminPrimaryButton
                        disabled={this.judgRegisterMessageButton()}
                        onClick={this.registerMessageButton}
                    >
                        登録
                    </AdminPrimaryButton>
                </PageFotterAreaRight>
                <PageFotterAreaLeft>
                    <BackLink
                        to={`/admin/messageList`}
                    >
                        メッセージ検索へ戻る
                    </BackLink>
                </PageFotterAreaLeft>
            </>
        )
    }

    renderDeliveryTargetArea(): ReactNode {

        return (
            <>
                <TableRow>
                    <TableRowName>
                        配信対象を地域から選択
                    </TableRowName>
                    <TableCell colSpan={3}>
                        <LeftRowFlexContainer>
                            <AdminDefaultMediumButton
                                onClick={this.handleOpenDeliveryTargetAreaSelectionDialog}
                                size={'small'}
                            >
                                地域を選択
                            </AdminDefaultMediumButton>
                            {this.state.deliveryTargetPrefectureCd !== '' || this.state.deliveryTargetAddress2 !== ''
                                ? <DeliveryTargetArea>
                                    <DeliveryTargetAreaTxt>
                                        {` 指定地域: `
                                            + this.getPrefectureName(this.state.deliveryTargetPrefectureCd)
                                            + this.state.deliveryTargetAddress2
                                        }
                                    </DeliveryTargetAreaTxt>
                                </DeliveryTargetArea>
                                : ``
                            }
                            {this.state.deliveryTargetPrefectureCd !== '' || this.state.deliveryTargetAddress2 !== ''
                                ? <DeleteLink onClick={(event: React.MouseEvent) => {
                                    event.preventDefault()
                                    this.setState({
                                        deliveryTargetPrefectureCd: '',
                                        deliveryTargetAddress2: '',
                                        selectedDeliveryTargetCondominiumInfo: [],
                                    })
                                }}>
                                    削除
                                </DeleteLink>
                                : ''
                            }
                        </LeftRowFlexContainer>
                        {this.state.dialogOpenSelectDeliveryTargetArea && this.state.condominiumGroup.details &&
                            <NatDeliveryTargetAreaSelectionComponent
                                condominiumRepo={this.props.condominiumRepo}
                                condominiumGroupRepo={this.props.condominiumGroupRepo}
                                closeSelectDeliveryTargetAreaDiaLog=
                                    {this.handleCloseDeliveryTargetAreaSelectionDialog}
                                setSelectedDeliveryTargetCondominiumInfo=
                                    {this.setSelectedDeliveryTargetCondominiumInfo}
                                setDeliveryTargetPrefectureCd={this.setDeliveryTargetPrefectureCd}
                                setDeliveryTargetAddress2={this.setDeliveryTargetAddress2}
                                eventEmitter={this.props.eventEmitter}
                                selectedCondominiumGroupId={this.state.messageRegisterParams.condominiumGroupId}
                                navigate={this.props.navigate}
                                location={this.props.location}
                                asyncCallFunction={this.props.asyncCallFunction}
                            />
                        }
                        {
                            <InnerMiniTable>
                                <InnerMiniTableBody>
                                    {
                                        this.state.selectedDeliveryTargetCondominiumInfo.map(
                                            (condominiumInfo, index) => {
                                                return (
                                                    <TableRow key={condominiumInfo.condominiumCd}>
                                                        <InnerMiniTableCell>
                                                            {condominiumInfo.condominiumCd + ' ' +
                                                                condominiumInfo.condominiumName}
                                                            <PPErrorLabel
                                                                eventEmitter={this.props.eventEmitter}
                                                                eventKeys={[`messageDeliveryTargetCondominium
                                                                [${index}].condominiumCd`]}
                                                            />
                                                        </InnerMiniTableCell>
                                                    </TableRow>
                                                )
                                            })
                                    }
                                </InnerMiniTableBody>
                            </InnerMiniTable>
                        }
                    </TableCell>
                </TableRow>
            </>
        )
    }

    renderMessagePreviewDialog(): ReactNode {
        return (
            <Dialog
                id={'pp-dialog'}
                open={this.state.preview}
                transitionDuration={(process.env.NODE_ENV === 'test') ? 0 : undefined}
                maxWidth={'xs'}
            >
                <CreatePreviewForResident
                    {...this.props}
                    categoryId={this.state.messageRegisterParams.categoryId}
                    publishStartDate={this.state.messageRegisterParams.publishStartDate}
                    title={this.state.messageRegisterParams.title}
                    description={this.state.messageRegisterParams.description}
                    messageFile={this.state.messageFileList}
                    onClose={this.previewCloseButton}
                />
            </Dialog>
        )
    }

    render(): ReactElement {
        if (!this.state.isLoadCompleted) {
            return (<></>)
        }
        return (
            <>
                <PageMainArea>
                    <form>
                        {this.renderInputFormTable()}
                    </form>
                    {this.renderMessagePreviewDialog()}
                </PageMainArea>
                <PageFooterArea>
                    {this.renderPageFooterArea()}
                </PageFooterArea>
            </>

        )
    }
}

export default createAdminPage(NatAdminMessageRegisterPage)

const SelectedNotDeliveryCondominium: StyledLabel = styled.label`
  white-space: nowrap;
  padding-left: 15px;
  padding-right: 15px;

  & .MuiInput-underline:before {
    border-bottom: none;
  }

  & .MuiInput-underline.Mui-error:after {
    border-bottom: none;
  }
`

const TermWrapper: StyledDiv = styled.div`
  display: flex;
  flex: 1 1 auto;
  justify-items: center;
  align-items: center;
  max-width: 35%;
`

const TermTxt: StyledSpan = styled.span`
  padding: 0 5px 0 5px;
`

const DocumentNameWrapper: StyledDiv = styled.div`
  display: flex;
  flex: 1 1 auto;
  align-items: flex-end;
  padding-right: 15px;
`

const DocumentWrapper = styled(DocumentNameWrapper)`
  display: flex;
  flex: 1 0 auto;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  padding-right: 15px;
  max-width: 40%;
`

const DeliveryTargetAreaTxt: StyledSpan = styled.span`
  font-weight: ${FontWeights.Bold};
`
const DeliveryTargetArea: StyledLabel = styled.label`
  white-space: nowrap;
  padding-left: 15px;
  padding-right: 15px;

  & .MuiInput-underline:before {
    border-bottom: none;
  }

  & .MuiInput-underline.Mui-error:after {
    border-bottom: none;
  }
`

const AlreadyDocumentWrapper = styled(DocumentNameWrapper)`
  flex: 1 1 0%;
  align-items: center;
`

const OrderWrapper = styled(AlreadyDocumentWrapper)`
  max-width: 10%;
`

const DocumentFormWrapper: StyledDiv = styled.div`
  flex: 1 0 auto;
  width: 100%;
`

const DocumentAddButtonWrapper: StyledDiv = styled.div`
  flex: 0 0 auto;
`

const TableCellLabelNoLeftPadding: StyledLabel = styled.label`
  padding: 0 10px 0 0;
`

const FlexBasis: StyledDiv = styled.div`
  flex: 1 1 0%;
`
